import React, { PureComponent } from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom"; // import GalleryComponent from '../../components/gallery'
import Layout from "../components/Layout";
import { getLocalStorage } from "../lib/session";
import { PrivateRoutes } from "../routes";

const Homepage = (props) => {
  const PrivateRoute = (props) => {
    if (!getLocalStorage("token")) {
      return <Redirect to={{ pathname: "/auth" }} />;
    }
    return <Route exact {...props} />;
  };

  return (
    <React.Fragment>
      {/* <Router> */}
        {/* <Layout> */}
          <Switch>
            {PrivateRoutes.map(({ component: Cmp, ...route }, index) => (
              <PrivateRoute
                exact
                key={"privateRoute" + index}
                {...route}
                render={(routeProps) => <Cmp {...props} {...routeProps} />}
              />
            ))}
          </Switch>
        {/* </Layout> */}
      {/* </Router> */}
    </React.Fragment>
  );
};

export default Homepage;
